export { NavLink, type NavLinkProps } from "@mantine/core";

export { getNavLinkOverrides } from "./NavLink.styled";
